var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.8146 3 17.3274 4.29197 18.9777 6.3152L11.3536 13.9393C11.1583 14.1346 10.8417 14.1346 10.6464 13.9393L7.35355 10.6464C7.15829 10.4512 6.84171 10.4512 6.64645 10.6464C6.45118 10.8417 6.45118 11.1583 6.64645 11.3536L9.93934 14.6464C10.5251 15.2322 11.4749 15.2322 12.0607 14.6464L19.5727 7.13441C20.476 8.53731 21 10.2075 21 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircled);
export default __webpack_public_path__ + "static/media/check_circled.123af72fe0bed4748c05cb1656d6f2b4.svg";
export { ForwardRef as ReactComponent };